<template>
	<transition name="fade" mode="out-in">
		<div v-if="is_loading_page" key="is-loading-page" class="box-loading">
			<div class="spinner-border text-primary" role="status">
				<span class="sr-only">Loading...</span>
			</div>
		</div>
		<div v-else  key="is-loading-page-success">
			<router-view />
		</div>
	</transition>
</template>
<script>
import { mapActions } from 'vuex';
	export default {
		name: 'VueLayout',
		data(){
			return {
				is_loading_page : true,
			}
		},
		methods:{
			...mapActions({
				getDefault : 'offer/getDefault'
			})
		},
		created(){
			this.is_loading_page = true 
			this.getDefault().finally(()=>{
				this.is_loading_page = false
			})
		}
	}
</script>